var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoann(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 36,
    viewBox: "0 0 187 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3625 23.001C16.3625 26.9591 14.6172 29.2343 11.5317 29.2343C8.976 29.2343 7.32417 28.1746 5.45417 25.3385L4.61267 24.0606L0 28.0188L0.592167 28.985C3.11667 33.1301 6.79433 35.2183 11.4693 35.2183C18.3572 35.2183 22.6582 30.5121 22.6582 22.9698V0.529785H16.3625V23.001Z",
    fill: "#83BD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8682 17.7027C60.8682 24.3412 56.1308 29.3278 49.8663 29.3278C43.6018 29.3278 38.771 24.2788 38.771 17.6092C38.771 10.9395 43.5083 5.984 49.7728 5.984C56.0373 5.984 60.8682 11.0018 60.8682 17.7027ZM49.8663 0C40.0488 0 32.3818 7.79167 32.3818 17.7027C32.3818 27.6137 39.8618 35.3118 49.7728 35.3118C59.6838 35.3118 67.2573 27.5202 67.2573 17.6092C67.2573 7.69817 59.7773 0 49.8663 0Z",
    fill: "#83BD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.845 0.529785V23.2503L121.987 0.529785H116.626V34.782H122.797V11.4381L141.185 34.782H146.016V0.529785H139.845Z",
    fill: "#83BD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.86 0.529785V23.2503L162.97 0.529785H157.641V34.782H163.812V11.4381L182.169 34.782H187V0.529785H180.86Z",
    fill: "#83BD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6484 21.6919L90.2584 9.10052L94.9022 19.6037C93.0634 19.853 91.2557 20.2894 89.4792 20.6945C87.8586 21.0685 86.2691 21.4425 84.6484 21.6919ZM106.372 26.585L108.242 27.3642V21.536L107.431 21.1932C106.06 20.601 103.255 19.9465 101.634 19.666L92.8764 0.311523H87.7962L78.1657 21.5984C77.0749 21.3179 75.7971 20.8504 74.8309 20.4452L72.9609 19.666V25.4942L73.7712 25.837C74.4257 26.1175 75.1737 26.4292 75.8594 26.6785L72.2129 34.7507H78.8202L82.0616 27.52C84.8666 27.4265 87.5469 26.8032 90.1337 26.211C92.5959 25.65 94.9334 25.089 97.3332 24.9644L101.665 34.7507H108.46L104.502 25.9929C105.343 26.2422 106.06 26.4604 106.372 26.585Z",
    fill: "#83BD25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 35.3118,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoann);
export default __webpack_public_path__ + "static/media/JOANN.ae44dbf0375860a74cfed878bb686d33.svg";
export { ForwardRef as ReactComponent };